import React from 'react';

import { ListIcon } from '@vlabs/icons';
import { routes } from '@vlabs/shared/navigation/routes';
import type { WithClassNameProp, WithDataTestid } from '@vlabs/uikit/types';
import cn from 'classnames';
import { generatePath } from 'react-router-dom';

import { useGetList } from '@vlabs/api/artemy/client';
import type { ListId } from '@vlabs/api/artemy/model';
import { buildTestid } from '@vlabs/monokit/shared/lib/utils';
import { Link } from '@vlabs/monokit/shared/ui/link';

import st from './List.module.sass';

interface ListProps extends WithClassNameProp, WithDataTestid {
  listId: ListId;
  actions?: React.ReactNode;
}

const displayName = 'List';
const testId = buildTestid(displayName);

function List({
  listId,
  actions = undefined,
  className = undefined,
  'data-testid': dataTestId = undefined,
}: ListProps): React.JSX.Element {
  const getList = useGetList(listId);
  const listTitle = getList.data?.user_data;

  return (
    <div
      className={cn(st.Root, className)}
      {...testId(dataTestId)}
    >
      <div className={st.TitleLink}>
        <ListIcon />
        <Link
          size="medium"
          to={generatePath(routes?.lists?.read, { listId })}
          type="secondary"
        >
          {listTitle}
        </Link>
      </div>

      {actions}
    </div>
  );
}

export { List };
